<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewSettings.prices_types.title') }}</h3>
    <v-card class="mt-2" elevation="0">
      <v-flex xs12 lg6>
        <v-form ref="priceTypeForm">
          <v-text-field
              outlined
              v-if="fetched || !!this.$route.params.id"
              :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
              :value="priceType"
              v-model="priceType"
              :label="$t('common.title')"
          ></v-text-field>
          <v-text-field
              outlined
              v-if="fetched || !!this.$route.params.id"
              :rules="[(v) => !!v || $t('form.validationErrors.field_is_required'), (v) => (parseFloat(v)>=0 && parseFloat(v)<=100) || $t('form.validationErrors.between', [0, 100])]"
              :value="coefficient"
              v-model="coefficient"
              :label="$t('common.coefficient_discount')"
          ></v-text-field>
          <v-checkbox
              :value="1"
              v-if="fetched || !!this.$route.params.id"
              v-model="is_default"
              :label="$t('viewSettings.prices_types.is_default_level')"
              hide-details
              class="mb-5 mt-0"
          ></v-checkbox>
          <v-checkbox
              value="1"
              v-if="fetched || !!this.$route.params.id"
              v-model="for_suppliers_price_with_margin"
              :label="$t('viewSettings.prices_types.for_suppliers_price_with_margin')"
              hide-details
              class="mb-5 mt-0"
          ></v-checkbox>
          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5 white--text mr-4"
              elevation="0"
              color="red"
              @click="$router.push({name: 'settings-prices-types'});"
              @keyup.enter="$router.push({name: 'settings-prices-types'});"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5"
              elevation="0"
              color="primary"
              @click="submit"
              @keyup.enter="submit"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-card>
  </div>
</template>
<script>
import {required, email, sameAs, minLength,} from "vuelidate/lib/validators";
import {mapState} from 'vuex';
import {mapFields} from 'vuex-map-fields';

export default {
  data: () => ({
    emptyPriceType: {
      name: '',
      coefficient: 100,
      for_suppliers_price_with_margin: false,
      is_default: 0
    }
  }),
  created() {
    this.onLoad();
  },

  watch: {
    '$route'(to, from) {
      this.onLoad();
    }
  },
  computed: {
    ...mapFields('prices_types', [
      'fetched',
      'savingInProgress',
      'pricesTypes'
    ]),
    editedPriceType() {
      if (this.$route.params.id > 0 && this.fetched && this.pricesTypes.length) {
        return this.pricesTypes.filter(priceType => Number(priceType.id) === Number(this.$route.params.id))[0] && this.pricesTypes.filter(priceType => Number(priceType.id) === Number(this.$route.params.id))[0]
      } else {
        return this.emptyPriceType;
      }
    },
    priceType: {
      // getter
      get: function () {
        return this.editedPriceType.name
      },
      // setter
      set: function (newValue) {
        if (this.$route.params.id > 0) {
          let priceType = this.pricesTypes.filter(priceType => Number(priceType.id) === Number(this.$route.params.id))
          priceType[0].name = newValue;
        } else {
          this.emptyPriceType.name = newValue;
        }
      }
    },
    coefficient: {
      // getter
      get: function () {
        return this.editedPriceType.coefficient;
      },
      // setter
      set: function (newValue) {
        if (this.$route.params.id > 0) {
          let priceType = this.pricesTypes.filter(priceType => Number(priceType.id) === Number(this.$route.params.id))
          priceType[0].coefficient = newValue;
        } else {
          this.emptyPriceType.coefficient = newValue;
        }
      }
    },
    is_default: {
      // getter
      get: function () {
        return this.editedPriceType.is_default;
      },
      // setter
      set: function (newValue) {
        if (this.$route.params.id > 0) {
          let priceType = this.pricesTypes.filter(priceType => Number(priceType.id) === Number(this.$route.params.id))
          priceType[0].is_default = newValue;
        } else {
          this.emptyPriceType.is_default = newValue;
        }
      }
    },
    for_suppliers_price_with_margin: {
      // getter
      get: function () {
        return this.editedPriceType.for_suppliers_price_with_margin;
      },
      // setter
      set: function (newValue) {
        if (this.$route.params.id > 0) {
          let priceType = this.pricesTypes.filter(priceType => Number(priceType.id) === Number(this.$route.params.id))
          priceType[0].for_suppliers_price_with_margin = newValue;
        } else {
          this.emptyPriceType.for_suppliers_price_with_margin = newValue;
        }
      }
    }
  },
  methods: {
    onLoad() {
      if (this.$route.params.id > 0) {
        this.$store.dispatch('prices_types/get').then(() => {
          if (!this.pricesTypes.filter(item => Number(item.id) === Number(this.$route.params.id))) {
            this.$router.push({name: '404'})
          }
        });
      }
    },
    submit() {
      if (this.$refs['priceTypeForm'].validate()) {
        if (this.$route.params.id > 0) {
          this.$store.dispatch('prices_types/update', {id: this.$route.params.id}).then((id) => {
            if (id > 0) {
              this.$router.push({name: 'settings-prices-types'});
            }
          })
        } else {
          this.$store.dispatch('prices_types/store', {priceType: this.emptyPriceType}).then((id) => {
            if (id > 0) {
              this.$router.push({name: 'settings-prices-types'});
            }
          })
        }
      }
    }
  },
}
</script>